import { createContext, useContext, useEffect, useMemo, useState } from "react";

// Lets a page name itself in the breadcrumb. The layout wraps the page in the provider, the
// breadcrumb reads the title, and the page calls usePageTitle(name):
// - by default the name replaces the last crumb (a campaign's name instead of "Execution Detail")
// - with { append: true } it is added as one more crumb (the profile's current tab)
const BreadcrumbTitleContext = createContext(null);

export function BreadcrumbTitleProvider({ children }) {
  const [title, setTitle] = useState(null);
  const value = useMemo(() => ({ title, setTitle }), [title]);
  return (
    <BreadcrumbTitleContext.Provider value={value}>
      {children}
    </BreadcrumbTitleContext.Provider>
  );
}

// { label, append } or null
export function useBreadcrumbTitle() {
  return useContext(BreadcrumbTitleContext)?.title ?? null;
}

export function usePageTitle(label, { append = false } = {}) {
  const setTitle = useContext(BreadcrumbTitleContext)?.setTitle;
  useEffect(() => {
    if (!setTitle || !label) return undefined;
    setTitle({ label, append });
    return () => setTitle(null);
  }, [setTitle, label, append]);
}
